import { useState } from 'react';
import { Label, IconButton, Text, FontSizes, Separator } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

// Functions 
import { connect } from 'react-redux';
import * as ComponentFunctions from './SettlementDetailItem.Functions';

// Components
import SettlementDetailForm from '../SettlementDetailForm/SettlementDetailForm.Component';
import SettlementDetailFormReview from '../SettlementDetailsFormReview/SettlementDetailsFormReview.Component';

// Styles
import './SettlementDetailItem.Styles.css';
import MOMENT from 'react-moment';
import { DetailType } from '../../../models/Entities/SettlementDetails/NewSettlementDetail';
import { MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';
import SettlementDetailValuesComponent from '../SettlementDetailValues/SettlementDetailValues.Component';


const SettlementDetailItem = (props: ComponentFunctions.Props) => {

    //useTranslation();
    const [t] = useTranslation();

    // form control 

    const [showDetailForm, setShowDetailForm] = useState<boolean>(false);
    const [showDetailsFormReview, setShowDetailsFormReview] = useState<boolean>(false);

    const handleClosePanel = () => {
        console.log('cerrando panel');
        setShowDetailForm(false);
    };

    const handleClosePanelReview = () => {
        setShowDetailsFormReview(false);
    };

    // actions
    const HandleEditConcept = () => {
        setShowDetailForm(true);
    };

    const HandleShowReviewForm = () => {
        setShowDetailsFormReview(true);
    }

    const Options = (
        <>
            <IconButton
                iconProps={ComponentFunctions.EditIcon}
                title={t('settlementDetailList.buttons.editButton')}
                onClick={HandleEditConcept}
            />
            {<IconButton
                iconProps={ComponentFunctions.ItemObservedIcon}
                title="Observar"
                style={{ color: 'gray' }}
                onClick={HandleShowReviewForm}
            />}
        </>
    )

    const Forms = props.CurrentDetail && (
        <>
            {showDetailForm && <SettlementDetailForm
                isOpen={showDetailForm}
                dismissPanel={handleClosePanel}
                openPanel={() => undefined}
                SettlementId={props.SettlementId}
                SettlementResumeId={props.CurrentDetail.settlementResumeId}
                SettlementDetailId={props.CurrentDetail.id}
            />}
            <SettlementDetailFormReview
                isOpen={showDetailsFormReview}
                dismissPanel={handleClosePanelReview}
                openPanel={() => undefined}
                SettlementId={props.SettlementId}
                SettlementDetailId={props.CurrentDetail.id}
            />
        </>
    )


    return (
        <>
            <div className={'DetailItemContainer ' + ComponentFunctions.GetStatusClass(props.CurrentDetail)} >
                <div className='DetailInfo'>
                    <div>
                        {(props.CurrentDetail?.contractStageName || props.CurrentDetail?.patientNumberInProtocol) &&
                            <Text style={{ fontSize: FontSizes.small }}>{props.CurrentDetail?.contractStageName}
                                {(props.CurrentDetail?.patientNumberInProtocol && <span> - {props.CurrentDetail?.patientNumberInProtocol}</span>)}
                                {/* {props.CurrentDetail?.notEnoughInfo && <span className='DetailSatusBagded red'>No hay suficiente información para calcular el valor</span>} */}
                            </Text>}
                        <Label style={{ fontSize: FontSizes.mediumPlus }}>{props.CurrentDetail?.description}
                            {
                                <span className={'DetailSatusBagded ' + ComponentFunctions.GetStatusClass(props.CurrentDetail)}>{t(ComponentFunctions.GetStatusText(props.CurrentDetail))}</span>}
                            {(props.CurrentDetail?.tag1 && props.CurrentDetail?.tag1?.length > 0) && <span className={'DetailSatusBagded warning'} style={{ fontSize: FontSizes.size12 }}>{props.CurrentDetail?.tag1}</span>}
                            {(props.CurrentDetail?.tag2 && props.CurrentDetail?.tag2?.length > 0) && <span className={'DetailSatusBagded warning'} style={{ fontSize: FontSizes.size12 }}>{props.CurrentDetail?.tag2}</span>}
                            {(props.CurrentDetail?.tag3 && props.CurrentDetail?.tag3?.length > 0) && <span className={'DetailSatusBagded warning'} style={{ fontSize: FontSizes.size12 }}>{props.CurrentDetail?.tag3}</span>}
                            {(props.CurrentDetail?.tag4 && props.CurrentDetail?.tag4?.length > 0) && <span className={'DetailSatusBagded warning'} style={{ fontSize: FontSizes.size12 }}>{props.CurrentDetail?.tag4}</span>}
                        </Label>

                    </div>
                    <Text>{props.DetailTotalValue.toLocaleString('es-AR', { style: 'currency', currency: props.CurrentDetail?.currency?.toUpperCase() })}</Text>
                </div>
                <div className='AditionalInfomationContainer'>
                    <div className='InformacionContainer'>
                        <Separator />
                        <table className="SettlementSummaryTable">
                            <thead>
                                <tr>
                                    <th>Paciente</th>
                                    <th>Fecha</th>
                                    <th>Concepto</th>
                                    <th>WithHolding</th>
                                    <th colSpan={2}>División de honorarios</th>
                                    <th>Importe a cobrar</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th>Centro</th>
                                    <th>Equipo médico</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* {CurrentDetail?.map((detail: SettlementDetail) =>
                                    <tr key={detail.id}>
                                        <td>{detail.patientNumberInProtocol}</td>
                                        <td>{moment(detail.dueDate).format('DD/MM/YYYY')}</td>
                                        <td>{detail.conceptName}</td>
                                        <td style={{ textAlign: 'right' }}>{detail.withHolingAmount.toLocaleString('es-AR', { style: 'currency', currency: detail.currency.toUpperCase() })}</td>
                                        <td style={{ textAlign: 'right' }}>{detail.ownerAmount.toLocaleString('es-AR', { style: 'currency', currency: detail.currency.toUpperCase() })}</td>
                                        <td style={{ textAlign: 'right' }}>{detail.teamAmount.toLocaleString('es-AR', { style: 'currency', currency: detail.currency.toUpperCase() })}</td>
                                        <td style={{ textAlign: 'right' }}>{detail.ownerAmount.toLocaleString('es-AR', { style: 'currency', currency: detail.currency.toUpperCase() })}</td>
                                    </tr>
                                )} */}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            {Forms}
        </>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementDetailItem as any);